import { UIText1, UIHeading2, Button } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './NoLinksPopup.css';

type TNoLinksPopupProps = {
  onClick?: () => void;
};

export const NoLinksPopup: React.FC<TNoLinksPopupProps> = ({ onClick }) => {
  return (
    <div className={styles['container']} data-testid="NoLinksPopup">
      <div className={styles['attention']} />
      <div className={styles['text']}>
        <UIHeading2>Не можем отправить ссылку</UIHeading2>
        <UIText1>Удалите её из сообщения, чтобы продолжить разговор</UIText1>
      </div>
      <Button onClick={onClick}>Удалить ссылку</Button>
    </div>
  );
};
